import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
	if (onPerfEntry instanceof Function) {
		import('web-vitals').then(({
									   getCLS,
									   getFID,
									   getFCP,
									   getLCP,
									   getTTFB
								   }) => {
			// 시각적 안정성 측정
			getCLS(onPerfEntry);

			// 상호 작용 측정
			getFID(onPerfEntry);

			// DOM 콘텐츠를 렌더링하는데 걸리는 시간 측정
			getFCP(onPerfEntry);

			// 로딩 성능 측정
			getLCP(onPerfEntry);

			// HTTP 요청을 했을때 처음 byte (정보) 가 브라우져에 도달하는 시간 측정
			getTTFB(onPerfEntry);
		});
	}
};

export default reportWebVitals;